export function normalizeMarkdownValue(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function shouldSyncVditorValue(editorValue: string, externalValue: unknown): boolean {
  return editorValue !== normalizeMarkdownValue(externalValue);
}
